export default __webpack_public_path__ + "static/media/nftImg.1c30ac1d.png";